import type { InventorizationTechnicalDetails } from '@/features/inventorization/domain/inventorization-technical';

export function normalizeTechnicalDetails(technical: InventorizationTechnicalDetails): InventorizationTechnicalDetails {
  const normalizedOutputs = technical.outputs.map(output =>
    output.isOccupied
      ? output
      : {
          ...output,
          remoteReadingOwner: '',
        },
  );

  return {
    ...technical,
    outputs: normalizedOutputs,
  };
}
